import React, { useState } from 'react';
import { PropTypes } from 'prop-types';

import Map from 'components/DriverMap/Map';
import Error from 'components/DriverMap/Error';

const DriverMap = ({ stops, drivers }) => {
  const [showError, setShowError] = useState(false);
  return (
    <>
      {showError && <Error />}
      <Map stops={stops} drivers={drivers} handleShowError={setShowError} />
    </>
  );
};

DriverMap.propTypes = {
  stops: PropTypes.arrayOf(PropTypes.shape({})),
  drivers: PropTypes.arrayOf(PropTypes.shape({})),
};

DriverMap.defaultProps = {
  stops: [],
  drivers: [],
};

export default DriverMap;
